import { UserRound } from "lucide-react";
import { useState } from "react";
import { isPlayerAvatarId } from "@ma-soi/game-core";

function initials(name: string) {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  return parts.slice(-2).map((part) => part[0]?.toUpperCase()).join("");
}

export function seatAvatarSrc(seat: number) {
  if (!isPlayerAvatarId(seat)) return null;
  return `/assets/ui/cast/seat-${String(seat).padStart(2, "0")}.webp`;
}

export function SeatAvatar({
  seat,
  avatarId,
  name,
  muted = false,
  className = "",
}: {
  seat: number;
  avatarId?: number;
  name: string;
  muted?: boolean;
  className?: string;
}) {
  const src = seatAvatarSrc(isPlayerAvatarId(avatarId) ? avatarId : seat);
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  return (
    <span className={`seat-avatar ${muted ? "seat-avatar-muted" : ""} ${className}`.trim()}>
      {src && failedSrc !== src ? (
        <img src={src} alt="" width="384" height="384" draggable={false} loading="lazy" onError={() => setFailedSrc(src)} />
      ) : name ? (
        <span aria-hidden="true">{initials(name)}</span>
      ) : (
        <UserRound aria-hidden="true" />
      )}
      <span className="sr-only">Ảnh đại diện của {name}</span>
    </span>
  );
}

export function NeutralAvatarStack({ count }: { count: number }) {
  const visible = Math.min(3, Math.max(1, count));
  return (
    <span className="neutral-avatar-stack" aria-label={`${count} người đang trong phòng`}>
      {Array.from({ length: visible }, (_, index) => (
        <span key={index} aria-hidden="true"><UserRound /></span>
      ))}
    </span>
  );
}
